document.addEventListener('DOMContentLoaded', function () {

    const tabsInit = () => {
        const tabsInstances = document.querySelectorAll('.block-tabs');

        tabsInstances.forEach((instance) => {
            const tabsNav = instance.querySelector('.block-tabs__nav');
            const contentItems = instance.querySelectorAll('.block-tabs__content-item');

            contentItems.forEach((contentItem, c) => {
                if ( c !== 0 ) {
                    contentItem.classList.remove('block-tabs__content-item--open');
                    tabsNav.innerHTML = tabsNav.innerHTML + '<li class="swiper-slide block-tabs__nav-item" data-tab="'+ contentItem.id +'">'+ contentItem.id +'</li>';
                }
                else {
                    tabsNav.innerHTML = tabsNav.innerHTML + '<li class="swiper-slide block-tabs__nav-item block-tabs__nav-item--open" data-tab="'+ contentItem.id +'">'+ contentItem.id +'</li>';
                }
            });

            switchTabs(instance);
            tabsMobileSlider(instance);
        });
    };

    const switchTabs = (instance) => {

        const tabNavItems = instance.querySelectorAll('.block-tabs__nav-item');
        const contentItems = instance.querySelectorAll('.block-tabs__content-item');

        tabNavItems.forEach((tab) => {
            tab.addEventListener('click', () => {
                tabNavItems.forEach(tab => tab.classList.remove('block-tabs__nav-item--open'));
                tab.classList.add('block-tabs__nav-item--open');
                contentItems.forEach((contentItem) => {
                    contentItem.classList.remove('block-tabs__content-item--open');
                    if (tab.dataset.tab === contentItem.id) {
                        contentItem.classList.add('block-tabs__content-item--open');
                    }
                });
            });
        });
    };

    const changeSliderSpacing = (instance) => {

        const btnPrev = instance.querySelector('.slider-button__prev');
        const btnNext = instance.querySelector('.slider-button__next');
        const tabsNav = instance.querySelector('.swiper');

        if (btnPrev.classList.contains('swiper-button-disabled')) {
            tabsNav.classList.add('has-no-left-margin');
        } else {
            tabsNav.classList.remove('has-no-left-margin');
        }

        if (btnNext.classList.contains('swiper-button-disabled')) {
            tabsNav.classList.add('has-no-right-margin');
        } else {
            tabsNav.classList.remove('has-no-right-margin');
        }
    };

    const tabsMobileSlider = (instance) => {
        const prev = instance.querySelector('.slider-button__prev');
        const next = instance.querySelector('.slider-button__next');

        new Swiper(instance.querySelector('.swiper'), {
            slidesPerView: 'auto',
            watchOverflow: true,
            navigation: {
                prevEl: prev,
                nextEl: next,
            },
            on: {
                afterInit: changeSliderSpacing(instance),
                slideChange: changeSliderSpacing(instance),
                toEdge: changeSliderSpacing(instance),
                resize: changeSliderSpacing(instance)
            }
        });

        if ( prev.classList.contains('swiper-button-disabled') ) {
            instance.classList.add('nav-no-prev');
        }

        if ( next.classList.contains('swiper-button-disabled') ) {
            instance.classList.add('nav-no-next');
        }
    };

    tabsInit();

});
